import { Injectable } from '@angular/core';
import { RestfulService } from 'app/shared/services/restful.service';
import { of } from 'rxjs';

@Injectable()
export class PraiseService {
  constructor(public restfulWebService: RestfulService) {}

  getGlobalInfo(dateRange: string) {
    return this.restfulWebService.get(
      `Praise/GlobalInfo?dateRange=${dateRange}`
    );
  }

  // ByBehaviorSkills
  getItemsByBehaviorSkills(body: any) {
    return this.restfulWebService.post(`Praise/ItemsByBehaviorSkills`, body);
  }
  getItemsPersonsByBehaviorSkills(itemId: string, item2Id: string, body: any) {
    return this.restfulWebService.post(
      `Praise/ItemsPersonsByBehaviorSkills?itemId=${itemId}&item2Id=${item2Id}`,
      body
    );
  }

  getDistinctPersonsBYBehaviorSkills(body: any) {
    return this.restfulWebService.post(
      `Praise/DistinctPersonsByBehaviorSkills`,
      body
    );
  }
}
